import styled from "styled-components";

export const VerifyEmailStyle=styled.div`
.body{
    background-color:white;
    margin-top:10vh;
    width:100%;
    height:90vh;
    justify-content: center;
    display: flex;
    align-items: center;
    flex-direction:column;
}



.smsTxt2{
  font-weight:500;
  color:black;
  font-family:  "Decimal A", "Decimal B", Avenir, "Helvetica Neue", Helvetica, "Arial Narrow", sans-serif;
  font-style:italic;
  font-size:12px;
  margin-top:1rem;
}

.smsTxt{
  font-weight:600;
  color:black;
  font-family:  "Decimal A", "Decimal B", Avenir, "Helvetica Neue", Helvetica, "Arial Narrow", sans-serif;
  width: fit-content;
  padding: 0 63px;
  text-align: center;
}

.form-button{
    background-color:hsl(33, 93%, 54%);
    border-color:white;
    margin-top:20px;
    margin-bottom:10px;
    color:white;
    font-family:  "Decimal A", "Decimal B", Avenir, "Helvetica Neue", Helvetica, "Arial Narrow", sans-serif;
    justify-content:center;
    font-size:17px;
    padding: 10px 10px;
    font-weight:700;
}

 

.description{
    font-weight: 800;
    font-size: 3vh;
    font-style: italic;
    margin: 2em 2em;
    color:black;
    font-family:  "Decimal A", "Decimal B", Avenir, "Helvetica Neue", Helvetica, "Arial Narrow", sans-serif;
    text-align:center;
}
/* For medium devices */
@media screen and (max-width: 576px) {
    .body{
        width: 100%;
    }

    
}
/* For small devices */
@media screen and (max-width: 350px) {
   

    
    .smsTxt{
        padding: 0px 37px;
    }
}
`